import { NgClass } from '@angular/common';
import { Component, Input, ViewEncapsulation } from '@angular/core';

import { DynamicHtmlDirective } from '@frontend/vanilla/core';

import { PromoClientContentLoader } from '../promo-client-content-loader.service';
import { PromoContentLoaderService } from '../promo-content-loader.service';
import { PromoPageDomManipulatorService } from '../promo-page-dommanipulator.service';

@Component({
    selector: 'collapsible-container',
    templateUrl: 'collapsible-container.component.html',
    imports: [NgClass, DynamicHtmlDirective],
    providers: [PromoContentLoaderService, PromoPageDomManipulatorService, PromoClientContentLoader],
    styleUrls: ['../../../../../themepark/themes/whitelabel/components/collapsible-container/styles.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class CollapsibleContainerComponent {
    collapsed: boolean = true;
    @Input() sitecoreHtml: string;
    @Input() h1Header: string;
    @Input() h2Header: string;
    clickEvent() {
        this.collapsed = !this.collapsed;
    }
}
